import React, { useEffect, useState, useRef } from "react";
import { Spin } from "../";
import { generateGUID } from "../../../util/Scripts";

export const Iframe = ({ 
   srcDoc, 
   className, 
   id = undefined, 
   scroll = false, 
   spinner = false, 
   onLoad 
}) => {
   const [iframeKey, setIframeKey] = useState("");
   const [iframeHeight, setIframeHeight] = useState(0);
   const ref = useRef(null);

   useEffect(() => {
      const GUID = generateGUID("iframe");
      setIframeKey(GUID);
   }, []);

   const handleIframeLoad = (e) => {
      // Set iframe height to content height + additional 10px is needed in some cases
      setIframeHeight(e.target.contentWindow?.document?.body?.scrollHeight + 10);
      onLoad && onLoad();
   };

   return (
      <>
         {spinner && iframeHeight === 0 ? <Spin /> : null}
         <iframe
            srcDoc={srcDoc}
            ref={ref}
            id={id}
            scrolling={scroll ? "yes" : "no"}
            height={iframeHeight}
            width={"100%"}
            className={`BP2Iframe ${className}`}
            key={iframeKey}
            style={{
               visibility: iframeHeight > 0 ? "visible" : "hidden",
               border: 0
            }}
            onLoad={(e) => handleIframeLoad(e)}
         ></iframe>
      </>
   );
};
